var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "transform-case",
      rawName: "v-transform-case"
    }],
    attrs: {
      "label": "Código da Habilidade",
      "outlined": "",
      "dense": "",
      "maxlength": "25"
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarHabilidades.apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.filters.codigo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "codigo", $$v);
      },
      expression: "form.filters.codigo"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Habilidade",
      "outlined": "",
      "maxlength": "25",
      "dense": ""
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarHabilidades.apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.filters.nome,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "nome", $$v);
      },
      expression: "form.filters.nome"
    }
  })], 1), _c('sca-select-ativo', {
    attrs: {
      "cols": 3,
      "config": {
        labelAtivo: 'Ativo',
        labelInativo: 'Inativo',
        label: 'Situação'
      }
    },
    on: {
      "enter": _vm.buscarHabilidades
    },
    model: {
      value: _vm.form.filters.ativo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "ativo", $$v);
      },
      expression: "form.filters.ativo"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sca-tooltip', {
    attrs: {
      "text": 'Buscar',
      "icon": 'mdi-magnify'
    },
    on: {
      "click": function ($event) {
        return _vm.buscarHabilidades();
      }
    }
  }), _c('sca-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('sca-tooltip', {
    attrs: {
      "text": 'Incluir',
      "icon": 'mdi-plus'
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterHabilidade();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.table.headers,
      "items": _vm.table.itens,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps,
      "show-expand": "",
      "no-data-text": _vm.table.noDataText
    },
    scopedSlots: _vm._u([{
      key: `item.codigo`,
      fn: function (_ref) {
        var _item$codigo;
        var item = _ref.item;
        return [_c('span', [_vm._v(_vm._s((_item$codigo = item.codigo) === null || _item$codigo === void 0 ? void 0 : _item$codigo.toUpperCase()))])];
      }
    }, {
      key: "expanded-item",
      fn: function (_ref2) {
        var headers = _ref2.headers,
          item = _ref2.item;
        return [_c('td', {
          staticClass: "blue-grey lighten-5",
          attrs: {
            "colspan": headers.length
          }
        }, [_c('p', {
          staticClass: "ml-4 my-0 text-wrap mx-70vw"
        }, [_vm._v(" " + _vm._s(item.descricao) + " ")])])];
      }
    }, {
      key: `item.situacao`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('sca-label-ativo', {
          attrs: {
            "ativo": item.ativo,
            "config": {
              labelAtivo: 'Ativo',
              labelInativo: 'Inativo'
            }
          }
        })];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('sca-tooltip', {
          attrs: {
            "text": 'Visualizar',
            "icon": 'mdi-eye-outline',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarHabilidade(item);
            }
          }
        }), _c('sca-tooltip', {
          attrs: {
            "text": 'Editar',
            "icon": 'mdi-pencil',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterHabilidade(item);
            }
          }
        }), _c('sca-tooltip', {
          attrs: {
            "text": `${item.situacao ? 'Inativar' : 'Ativar'}`,
            "icon": `${item.situacao ? 'mdi-toggle-switch-off' : 'mdi-toggle-switch'}`,
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.inativarAtivarHabilidade(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1), _c('CadastrarEditarHabilidadeDialog', {
    attrs: {
      "visible": _vm.dialogManterHabilidade.visible,
      "content": _vm.dialogManterHabilidade.content,
      "edit": _vm.dialogManterHabilidade.edit
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterHabilidade.close();
      },
      "onSave": function ($event) {
        return _vm.buscarHabilidades();
      }
    }
  }), _vm.dialogVisualizarHabilidade.visible ? _c('VisualizarHabilidadeDialog', {
    attrs: {
      "visible": _vm.dialogVisualizarHabilidade.visible,
      "content": _vm.dialogVisualizarHabilidade.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarHabilidade.close();
      }
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }